import React from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from './header';
import { Footer } from '../../../common/footer';
import { useStyles } from './layout-reg-guide.styles';

export const LayoutRegGuideV1 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <div
      className={classes.root}
      data-testid="layout-reg-guide"
    >
      <div className={classes.headerAndContentWrapper}>
        <Header />
        <Outlet />
      </div>
      <div className={classes.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
};
